import React from 'react';

const HouseContext = React.createContext();

export default  HouseContext;